<template>
  <el-dialog title="物料理论数量" :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false"
             width="80%">
    <SweetTable ref="table" api-version="v2" url="/erp/bom/query/with-product" :query-form="queryForm" :is-page="false"
                :height="500" :auto-load="false" :summaries-column="['totalCount','productCount']" :before-table-binding="beforeTableBinding">
      <el-table-column prop="orderCode" :label="$t('orderCode') " header-align="center"
                       align="center" width="160" :show-tooltip-when-overflow="true"></el-table-column>
      <el-table-column label="品番 " header-align="center"
                       align="center">
        <template #default="{row}">
          <ProductRowCard :product="row.product"></ProductRowCard>
        </template>
      </el-table-column>
      <el-table-column prop="productCount" label="订单数量 " header-align="center"
                       align="center" width="160"></el-table-column>
      <el-table-column prop="bomCount" label="理论单耗 " header-align="center"
                       align="center" width="120"></el-table-column>

      <el-table-column prop="totalCount" label="小计 " header-align="center"
                       align="center" width="160"></el-table-column>
    </SweetTable>
  </el-dialog>
</template>

<script>
import ProductRowCard from '@/components/ProductRowCard.vue'
import SweetTable from '@/mixins/SweetTable'
import BigNumber from 'bignumber.js'

export default {
  name: 'BomPlanTableDialog',
  mixins: [SweetTable],
  components: { ProductRowCard },
  data () {
    return {
      visible: false,
      queryForm: {
        materialId: '',
        orderId:''
      }
    }
  },
  methods: {
    beforeTableBinding(dataList){
      dataList.forEach(row=>{
        row.totalCount=new BigNumber(row.bomCount||0).multipliedBy(row.productCount||0).toFixed(3)
      })
    },
    init (materialId,orderId) {
      this.queryForm.materialId = materialId
      this.queryForm.orderId=orderId
      this.visible=true
      this.$nextTick(()=>{
        this.reload()
      })
    }
  }
}
</script>

<style scoped>

</style>
